import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const CE_NAMES = {
  'CE-01': 'Romance',
  'CE-02': 'Joy',
  'CE-03': 'Sorrow',
  'CE-04': 'Fury',
  'CE-05': 'Wonder',
  'CE-06': 'Dread',
  'CE-07': 'Revulsion',
  'CE-08': 'Valor',
  'CE-09': 'Serenity',
};

export function EmotionChip({
  ceCode,
  label,
  size = 'md',
  showDot = true,
  className,
  ...props
}) {
  if (!ceCode) return null;

  const displayName = label || CE_NAMES[ceCode] || ceCode;

  const sizeClasses = {
    sm: "px-2 py-[2px] text-[11px] gap-[6px]",
    md: "px-[10px] py-[3px] text-[12px] gap-[6px]",
  };

  const dotSizes = {
    sm: "h-[5px] w-[5px]",
    md: "h-[6px] w-[6px]",
  };

  return (
    <Badge
      ce={ceCode}
      variant="default"
      className={cn("items-center whitespace-nowrap", sizeClasses[size], className)}
      data-testid={`emotion-chip-${ceCode}`}
      {...props}
    >
      {showDot && CE_NAMES[ceCode] && (
        <span
          className={cn("rounded-full shrink-0 inline-block", dotSizes[size])}
          style={{ backgroundColor: "inherit", filter: "brightness(0.8)" }}
        />
      )}
      {displayName}
    </Badge>
  );
}